import React from "react";
import { DragDropContext } from "@hello-pangea/dnd";
import PlatformPipelineColumn from "./PlatformPipelineColumn";
import { SALES_STAGES, TERMINAL_STAGES } from "../../constants";

const PlatformPipelineBoard = ({ columns, onDragEnd, onCardClick, showArchived, onToggleArchive, archivedCount }) => {
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            {/* Toolbar de arquivo */}
            <div className="d-flex align-items-center justify-content-end mb-2 px-1">
                <button
                    className={`btn btn-sm d-flex align-items-center gap-1 crm-archive-toggle ${showArchived ? "active" : ""}`}
                    onClick={onToggleArchive}
                    title={showArchived ? "Ocultar leads arquivados" : "Exibir leads arquivados"}
                >
                    <i className="mdi mdi-archive-outline" />
                    {showArchived
                        ? "Ocultar Arquivo"
                        : `Arquivo${archivedCount > 0 ? ` (${archivedCount})` : ""}`}
                </button>
            </div>

            {/* Kanban Board */}
            <div className="crm-kanban-board">
                {SALES_STAGES.map(stage => {
                    const stageLeads = columns[stage.key] || [];
                    return (
                        <PlatformPipelineColumn
                            key={stage.key}
                            stage={stage}
                            leads={stageLeads}
                            onCardClick={onCardClick}
                            isTerminal={TERMINAL_STAGES.includes(stage.key)}
                        />
                    );
                })}
            </div>
        </DragDropContext>
    );
};

export default PlatformPipelineBoard;
